import API from '../../api';
import SVLS_API from '../../api-services/svls-api';
import {
  FATCH_LIVE_CASINO_GAMES,
  SET_SEARCH_GAME,
  HANDLE_SEARCH_GAME,
} from './CasinoActionTypes';

export const FatchCasinoGamesSuccess = (value: string) => {
  return {
    type: FATCH_LIVE_CASINO_GAMES,
    payload: value,
  };
};
export const FatchLiveCasinoGames = (gametype: string) => {
  return async (dispatch: Function) => {
    try {
      let response = null;
      if (sessionStorage.getItem('jwt_token')) {
        response = await API.post('/gap/enabled-games', null, {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        });
      } else {
        response = await API.post('/gap/enabled-games', null);
      }
      if (response.data) {
        if (gametype === 'Royal Gaming') {
          let gameList = response.data.filter(
            (g) => g.subProviderName === 'Royal Gaming'
          );
          dispatch(FatchCasinoGamesSuccess(gameList));
        } else {
          dispatch(FatchCasinoGamesSuccess(response.data));
        }
      } else {
        console.log('fatch casino error');
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const setSearchGame = (payload) => {
  return {
    type: SET_SEARCH_GAME,
    payload,
  };
};

export const handleSearchGame = () => {
  return {
    type: HANDLE_SEARCH_GAME,
  };
};
